import React from "react";
import PageHeader from '../components/PageHeader';
import About from '../components/PageSections/about.js';
import TeamExpanded from "../components/PageSections/team-expanded.js";
const AboutUs = () => {
  return (
    <>
      <PageHeader name="About Us" link="about-us" />


      {/* about section start */}
        <About />
      {/* about section end */}


      {/* team section start */}
        <TeamExpanded />
      {/* team section end */}
    </>
  );
};
  
export default AboutUs;